import { isArray, isEmpty, trim, getByteLen } from '@/common/js/utils'

export default {
  methods: {
    invalid(rules) {
      const arr = []
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? this[rule.name.split('/')[0]][rule.name.split('/')[1]] : this[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string' && !rule.charset) {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else if (typeof ruleName === 'string' && rule.charset === 'bc') {
          param = ruleName
          length = String(param).length
        } else if (typeof ruleName === 'number') {
          param = length = ruleName
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? this[rule.relyon.split('/')[0]][rule.relyon.split('/')[1]] : this[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if (rule.require && isEmpty(param)) {
          const msg = `${rule.desc}不能为空`
          this.formErr = true
          arr.push({ feild: rule.desc, msg: rule.msg || msg })
          continue
        }

        // 长度判断
        if (typeof param === 'string' || isArray(param)) {
          if (param && rule.max < length) {
            const msg = `${rule.desc}不能多于${rule.max}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (param && rule.min > length) {
            const msg = `${rule.desc}不能少于${rule.min}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }

        // 大小判断
        if (typeof param === 'number') {
          if (rule.max < length) {
            const msg = `${rule.desc}数值不能大于${rule.max}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (rule.min > length) {
            const msg = `${rule.desc}数值不能小于${rule.min}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }

        // 正则
        if (rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    },
    valid() {
      const rules = [
        {
          name: 'pages/pageInnerName',
          require: true,
          min: 2,
          max: 40,
          desc: '落地页名称'
        },
        {
          name: 'pages/pageName',
          require: true,
          min: 2,
          max: 40,
          desc: '页面名称'
        },
        {
          name: 'pages/multGame',
          require: true,
          min: 1,
          desc: '游戏'
        },
        {
          name: 'data',
          require: true,
          min: 1,
          desc: '组件',
          msg: '页面中至少添加一个组件'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    customValid(data) {
      let flag
      let index = 0
      for (const ret of data) {
        index++
        const { attr } = ret
        const verify = attr.map((met) => {
          if (met.relyon) {
            const relyon = attr[met.relyon.index]
            if (relyon && relyon[relyon.name] === met.relyon.value) {
              if (met[met.name] === 'href') { return !isEmpty(met[met.name]) && (met[met.name].startsWith('http://') || met[met.name].startsWith('https://')) } else return true
            } else return relyon[relyon.name] !== met.relyon.value
          } else if (isArray(met.children)) {
            return met.children.every((m) => isArray(m[m.name]) || !isEmpty(m[m.name]))
          } else if (['TEXT', 'TEXTAREA'].includes(met.element_type)) {
            const { readonly, pattern, max, min } = met.restriction
            const len = getByteLen(met[met.name])
            if (len) {
              if (pattern) {
                const reg = new RegExp(pattern, 'g')
                if (met.element_type === 'TEXT' && !reg.test(met[met.name])) return
                else if (met.element_type === 'TEXTAREA' && reg.test(met[met.name])) return
              }
              if (len > max) return
              if (len < min) return
            } else if (!readonly && met.required) return !isEmpty(met[met.name])
            return true
          } else {
            return !isEmpty(met[met.name])
          }
        })
        if (!verify.every((f) => f)) {
          flag = true
          break
        }
      }
      return flag ? index - 1 : -1
    }
  }
}
